import React, { MouseEvent } from 'react';
import './product-description.scss';
import ProductDescriptionExpander from 'components/product/product-description/product-description-expander';
import Link from 'atomic/utilization/link';
import ProductDescriptionIframe from 'components/product/product-description/product-description-iframe';

interface ProductDescriptionProps {
    description: {
        multimedia: string;
        html: string;
        text: string;
    };
}

const MAX_CHAR_LENGTH = 1426;

const ProductDescription: React.FC<ProductDescriptionProps> = ({ description }) => {
    if (description.multimedia) {
        return <ProductDescriptionIframe src={description.multimedia}/>;
    }

    const ScrollToAttributes = (e: MouseEvent<HTMLButtonElement | HTMLAnchorElement>): void => {
        e.preventDefault();

        const attributesDiv = document.getElementById('attributes');

        if (attributesDiv) {
            setTimeout(() => {
                attributesDiv.scrollIntoView({ behavior: 'smooth' });
            }, 0);
        }
    };

    return (
        <div className="product-description">
            <Link className="specification__button" href="#techniczne" title="Zobacz specyfikację"
                onClick={ScrollToAttributes}
            >
                Zobacz specyfikację
            </Link>
            <div
                className={`product-description__content ${description.text?.length < MAX_CHAR_LENGTH ? 'product-description__content--unfolded' : ''}`}
                dangerouslySetInnerHTML={{ __html: description.html }}
            />
            {description.text?.length > MAX_CHAR_LENGTH && (
                <ProductDescriptionExpander
                    parentClassName={'product-description__content'}
                />
            )}
        </div>
    );
};

export default ProductDescription;
